// ==================================================================================================
//
// Form Collapsed Group
// toggles open depending on value of other input
//
// ==================================================================================================
import I18n from '../i18n';
I18n;


const formCollapsedGroup = () => {
  let props = {
    toggled: false
  };
  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$inputToggle = $('.js-toggle-collapsed-group')
    els.$collapsedGroup = $('.js-collapsed-form-group')
    return;
  }

  // Set up default hidden state of group
  // ------------------------------------------------
  const setDefaultState = () => {
    if (els.$inputToggle.prop('checked')) {
      els.$collapsedGroup.hide()
    } else {
      els.$inputToggle.prop('checked', 'true')
      els.$collapsedGroup.hide()
    }
  }

  // Special validations for required groups
  // ------------------------------------------------
  const toggleHiddenGroup = () => {
    els.$collapsedGroup.slideToggle(300)
    props.toggled = !props.toggled

    // add validations to hidden fields
    const $newRequiredFields = els.$collapsedGroup.find('.js-required-if-visible')

    $newRequiredFields.each(function() {
      $(this).attr('aria-required', props.toggled ? 'true' : 'false')
      $(this).attr('data-parsley-required', props.toggled ? 'true' : 'false')
      $(this).attr('data-parsley-required-message', props.toggled ? I18n.t('required') : 'null')
      $(this).attr('data-parsley-trigger', props.toggled ? 'focusout' : 'null')

      if ($(this).hasClass('.js-zip-code')) {
        $(this).attr('data-parsley-error-message', props.toggled ? I18n.t('invalid zip code') : 'null')
        $(this).attr('data-parsley-pattern', props.toggled ? '\d{5}' : 'null')
      }
    })
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    setDefaultState()
    els.$inputToggle.on('change', toggleHiddenGroup)

    props.isEnabled = true;

    return;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    els.$inputToggle.off('change', toggleHiddenGroup)

    props.isEnabled = false;

    return;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    enable();
    return;
  }

  return {
    init,
    enable,
    disable
  };
}

export default formCollapsedGroup;
